<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '700px' }"
    header="Novo Arquivo"
    :modal="true"
    @hide="hideDialog"
  >
    <FileUpload
      name="demo[]"
      invalidFileTypeMessage="Tipo de arquivo inválido, tipos de arquivo permitidos: PNG, JPEG"
      invalidFileSizeMessage="Tamanho de arquivo inválido, o tamanho do arquivo deve ser no máximo 2 MB."
      :chooseLabel="'Escolher'"
      :maxFileSize="10000000"
      @select="onSelect"
      :fileLimit="1"
      :showUploadButton="false"
      @clear="onCancel"
    >
      <template #empty>
        <p class="p-text-center">Nenhum arquivo selecionado</p>
      </template>
    </FileUpload>

    <template #footer>
      <Button
        label="Salvar"
        class="p-button"
        icon="pi pi-check"
        @click="send"
      />
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button p-button-text"
        @click="hideDialog"
      />
    </template>
  </Dialog>
</template>
<script>
//Models
import File from "../../../models/file";

//Services
import FileService from "../../../service/file/file_service";

export default {
  props: ["selected", "selectedFolder"],
  data() {
    return {
      file: new File(),
      fileService: new FileService(),
      submitted: false,
      fileData: null,
      folder: null,
    };
  },
  created() {},
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.file.dialogForm;
        if (value === true) this.getData();
        return value;
      },
      set(value) {
        this.$store.state.views.file.dialogForm = value;
      },
    },
  },
  methods: {
    onSelect(obj) {
      this.fileData = obj.files[0];
    },
    send() {
      if (!this.file.id) {
        this.newUpload();
      } else {
        this.updatedUpload();
      }
    },
    /**UPANDO UM NOVO ARQUIVO**/
    newUpload() {
      this.fileService
        .upload(this.fileData, this.folder.identifier)
        .then((data) => {
          this.$msgSuccess(data);
          this.hideDialog();
        })
        .catch((response) => {
          //console.log(error.response);
          this.$msgErro(response);
        });
    },
    /** ATUALIZANDO UM ARQUIVO UPADO **/
    updatedUpload() {
      this.fileService
        .update(this.file.hashKey, this.fileData)
        .then((data) => {
          this.$msgSuccess(data);
          this.hideDialog();
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    hideDialog() {
      this.file = new File();
      this.submitted = false;
      this.fileData = null;
      this.folder = null;
      this.$emit("findAll");
      this.visibleDialog = false;
    },
    getData() {
      this.file = this.selected;
      this.folder = this.selectedFolder;
    },
  },
};
</script>
<style scoped></style>
